module.exports = __webpack_public_path__ + "img/folder-arrow-down.92a64222.svg";